import { extractProperty } from './extractProperty'


export function getStationSpacesForRent(umbracoStation?: any[]): string[] {
    if (!umbracoStation) return []

    const spacesForRentValues: string[] = []

    const spacesValue = extractProperty(umbracoStation, 'satiationSpacesForRent')
    if (spacesValue && Array.isArray(spacesValue)) {
        spacesValue.forEach((item: any) => {
            const blockValue = extractProperty(item, 'spacesNumber')
            if (blockValue !== null && blockValue !== undefined && blockValue !== '') {
                spacesForRentValues.push(blockValue.toString())
            }
        })
    }


    return spacesForRentValues
}

export default getStationSpacesForRent
